import { TableColumns, TableFilterTab } from '../../../../../../ui-components/lib/table/table.model';
import { ActionList } from '../../../../../common/models/action-list.model';

export const WORKFLOW_PERMISSION_COLUMNS: TableColumns[] = [
  { header: '', field: '' },
  {
    header: 'workflow_permission_list_screen_workflow_name_table_header',
    field: '',
    showViewIcon: true,
  },
  {
    header: 'workflow_permission_list_screen_workflow_category_table_header',
    field: '',
  },
  {
    header: 'workflow_permission_list_screen_workflow_owners_table_header',
    field: '',
  },
  {
    header: 'workflow_permission_list_screen_workflow_members_table_header',
    field: '',
  },
  { header: '', field: '' },
];

export const WORKFLOW_PERMISSION_COLUMNS_SORT: TableColumns[] = [
  { header: '', field: '' },
  {
    header: 'workflow_permission_list_screen_workflow_name_table_header',
    field: '',
    showViewIcon: true,
    isSortable: true,
    sortKey: 'name][type',
  },
  {
    header: 'workflow_permission_list_screen_workflow_category_table_header',
    field: '',
    isSortable: true,
    sortKey: 'category][type',
  },
  {
    header: 'workflow_permission_list_screen_workflow_owners_table_header',
    field: '',
  },
  {
    header: 'workflow_permission_list_screen_workflow_members_table_header',
    field: '',
    isSortable: true,
    sortKey: 'members_count][type',
  },
  { header: '', field: '' },
];

export const WORKFLOW_PERMISSION_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
};

export const WORKFLOW_PERMISSION_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
];
